import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const useLandingInstantOfferAnalyticsTrack = ({pageName} = {}) => {
  const {page: pageTrack, track} = useAnalyticsTrack()
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const {
    LANDING_IO_FIELD_AUTOCOMPLETED,
    LANDING_IO_FIELD_SELECTED,
    LANDING_IO_FORM_FIELDS_ERROR,
    LANDING_IO_NEXT_CONFIRMED,
    LANDING_IO_NEXT_VIEWED,
    LANDING_IO_OFFER_REQUESTED_ERROR,
    LANDING_IO_OFFER_REQUESTED
  } = config.get('tracking').TRACKING_EVENT_NAMES

  const trackFormFieldSelected = ({fieldId}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_FIELD_SELECTED,
        fieldId
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackFormFieldValueAutocompleted = ({fieldId}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_FIELD_AUTOCOMPLETED,
        fieldId
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackInstantOfferNoAvailable = () => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_OFFER_REQUESTED_ERROR
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackInstantOfferRequestConfirmed = () => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_OFFER_REQUESTED
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackFormFieldsError = ({formErrors = {}, isPrivacyChecked = true}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_FORM_FIELDS_ERROR,
        formErrors,
        isPrivacyChecked
      })
      .then(eventTrackingData => track(eventTrackingData))
  }

  const trackNextConfirmed = ({vehicleData}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_NEXT_CONFIRMED,
        vehicleData
      })
      .then(eventTrackingData => track(eventTrackingData))

    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: LANDING_IO_NEXT_VIEWED
      })
      .then(eventTrackingData => pageTrack(eventTrackingData))
  }

  return {
    trackFormFieldSelected,
    trackFormFieldsError,
    trackFormFieldValueAutocompleted,
    trackInstantOfferNoAvailable,
    trackInstantOfferRequestConfirmed,
    trackNextConfirmed
  }
}

export {useLandingInstantOfferAnalyticsTrack}
